module.exports = __webpack_public_path__ + "static/media/sunset_boy_pealing_egg.8a8bf889.jpg";